module.exports = __webpack_public_path__ + "static/media/CARETdOWNbg.30a39b6a.svg";